import { render, staticRenderFns } from "./StaffHoursDashboard.vue?vue&type=template&id=3ee3f728&scoped=true&"
import script from "./StaffHoursDashboard.vue?vue&type=script&lang=js&"
export * from "./StaffHoursDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StaffHoursDashboard.vue?vue&type=style&index=0&id=3ee3f728&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee3f728",
  null
  
)

export default component.exports